import { FC } from "react";
import { Box, Button, Flex, Space, Text, Textarea, Title } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { FileList, type Order } from "@jasper/shared";
import { useOrderHelpRequest } from "./useOrderHelpRequest";

type OrderGetHelpProps = {
  order: Order;
  closeModal?: () => void;
  refetch: () => void;
  id: string;
};

export const OrderGetHelp: FC<OrderGetHelpProps> = ({
  order,
  closeModal = () => null,
  refetch,
  id,
}) => {
  const {
    qrCodeCanvasRef,
    hasFiles,
    filesToShow,
    deleteOneHelpFile,
    refetchHelpFiles,
    setHelpRequestMessage,
    submit,
    error,
  } = useOrderHelpRequest({ order, id, refetch, onSent: closeModal });

  return (
    <Box>
      <Flex w="100%" justify="right">
        <IconX
          onClick={() => closeModal()}
          style={{ cursor: "pointer" }}
          color="black"
        />
      </Flex>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Title
          order={2}
          style={theme => ({
            color: theme.colors.primary[5],
          })}
        >
          Demande d&apos;aide pour la commande
        </Title>
        <Space h="md" />
        <Title
          order={2}
          style={theme => ({
            color: theme.colors.primary[5],
          })}
        >{`${order.orderReference}`}</Title>
        <Space h="md" />
        <Title order={4}>
          Votre conseiller Jasper reviendra vers vous très rapidement.
        </Title>
        <Space h="lg" />
        <p
          style={{
            textAlign: "center",
            margin: "0",
          }}
        >
          Ajoutez des photos
          <br />
          via ce QR Code
        </p>
        <canvas
          ref={qrCodeCanvasRef}
          style={{
            margin: "auto",
            maxWidth: "200px",
            maxHeight: "200px",
          }}
        />
        {hasFiles && (
          <FileList
            files={filesToShow}
            downloadOneFile={() => {}}
            deleteOneFile={deleteOneHelpFile}
            refetch={refetchHelpFiles}
          />
        )}
        <Textarea
          color="primary"
          placeholder="Veuillez indiquer la nature de votre demande d'aide"
          onChange={event => setHelpRequestMessage(event.target.value)}
          w="80%"
          autosize
          minRows={4}
          maxRows={12}
        />
        <Space h="md" />
        <Button onClick={submit}>Envoyer</Button>

        {error && (
          <>
            <Space h="sm" />
            <Text
              size="sm"
              style={theme => ({
                color: theme.colors.red[5],
              })}
            >
              Une erreur est survenue, veuillez contacter votre conseiller
              Jasper directement
            </Text>
          </>
        )}
      </Box>
      <Space h="md" />
    </Box>
  );
};
